var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiUpdateProffitSearchShareReceive } from '../../../../actions/ProffitSearchReceiveAction';
import { wrapNotifyError, wrapDispatch } from '../../../action';
import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../profile';
import { useBoolState } from '../../useHook';
/**
 * Proffit Searchのスライド受領を制御するuse
 * @param profile
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
export const useSlideSearchReceiveModal = (profile, dispatch, unmountRef) => {
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState(false);
    const { plan } = getProffitSearchValues(profile);
    const isFree = isProffitSearchFreePlan(plan);
    /**
     * スライド受領の更新処理
     * @type {(function(*): Promise<void>)|*}
     */
    const updateReceive = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiUpdateProffitSearchShareReceive(values.id));
            if (!unmountRef.current) {
                hideModal();
            }
        }));
    }), [dispatch, hideModal, unmountRef]);
    /**
     * スライド受領の更新処理（ボタン経由）
     * @type {(function(*): Promise<void>)|*}
     */
    const rawOnClickReceive = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        const { value: id } = e.currentTarget;
        yield updateReceive({ id });
    }), [updateReceive]);
    // フリープランであればモーダル表示、それ以外であれば更新処理を返す
    const onClickReceive = isFree ? showModal : rawOnClickReceive;
    return {
        hideModal,
        isFree,
        isShowModal,
        onClickReceive,
        showModal,
        updateReceive,
    };
};
export const useSlideSearchReceive = {
    useSlideSearchReceiveModal,
};
